import {
  Box,
  Divider,
  Heading,
  Hidden,
  Page,
  PageBlock,
  Stack,
  Text,
} from 'braid-design-system';

import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';

const PreferencesSubmitted = () => (
  <Page footer={<SiteWideFooter />} footerPosition="belowFold">
    <Header title="Customise your recommendations" />

    <Hidden below="tablet">
      <Divider />
    </Hidden>

    <Box paddingTop="xlarge">
      <PageBlock width="small">
        <Stack space="xlarge">
          <Stack space="medium">
            <Heading level="2" component="h1">
              Thank you!
            </Heading>

            <Text>
              Your business preferences have been updated. When we find newly
              listed businesses that match your preferences, we&apos;ll send
              them your way, straight to your inbox.
            </Text>
          </Stack>

          <Stack space="medium">
            <Heading level="4">How to edit/change your preferences:</Heading>

            <Text>
              You can make changes to your preferences at any time via your
              profile when logged in, or via the recommendations email. For now,
              sit back while we look for matching businesses.
            </Text>
          </Stack>
        </Stack>
      </PageBlock>
    </Box>
  </Page>
);

export default PreferencesSubmitted;
